<button [disabled]="disabled" (click)="login()" mat-button mat-raised-button color="primary">
  <img height="32" class="invert" src="https://amaia.jugacu.es/img/amaia.svg" alt="">
  Login with Amaia
</button>
